import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoggerService} from '../../shared/common-components/logger.service';
import {DataService} from '../data.service';
import {Carrier} from '../../shared/common-components/common-structure';
import {BehaviorSubject} from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class CarrierApprovalService extends DataService {

    private baseURI = this.apiUri + '/carrierapproval/';
    private _logger: LoggerService;
    carrier = new BehaviorSubject<Carrier>(new Carrier);

    constructor(http: HttpClient, logger: LoggerService) {
        super(http);
        this._logger = logger;
    }

    getCarrier(carrierId: string): Observable<any> {
        this.setUri(this.baseURI + carrierId + '/carrierId');
        return this.get();
    }

    getAll(): Observable<any> {
        this.setUri(this.baseURI);
        return this.get();
    }

    updateCarrier(organization: any): Observable<any> {
        this.setUri(this.apiUri + '/carrierapproval/carrierSave');
        return this.update(organization);
    }

  getTspCategories(carrierId: any): Observable<any> {
    this.setUri(this.apiUri + '/carrierapproval/specialty/' + carrierId + '/carrierId');
    return this.get();
  }

    //carrierapproval/tspapprovalreinstate
    reinstateCarrierApprovalWithMessage(deleteApprovalCarrierMappingEntity: string): Observable<any> {
        return this.http.put<any>(this.baseURI + 'tspapprovalreinstate',
          deleteApprovalCarrierMappingEntity,
          {headers: new HttpHeaders({'Content-Type': 'application/json'})});
      }

}
